export default (value: any) => {
    if (!value) return ''
    value = value.toString()
    return value.toUpperCase()
} 